import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es';
import axios from 'axios';
import './Slider.css';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { FaEye } from 'react-icons/fa';
import { FaComments } from 'react-icons/fa';

const API_URL = 'https://radioital.com/api/public/api/foros';
const Foros = () => {
  const [foros, setForos] = useState(null);
  
  useEffect(() => {
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.get(API_URL, {
      headers: {
        //'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer token' // si lo usas
      }
    })
      .then((res) => setForos(res.data.data));
  }, []);

  useEffect(() => {
    new Swiper('.sliderF', {
      autoplay:{
          delay: 7500,
          pauseOnMouseEnter: true,
          disableOnInteraction: true,
      },
      modules:[Autoplay, Pagination, Navigation, Scrollbar],
      direction: 'horizontal',
      loop: true,
      spaceBetween: 10,
      slidesPerView: 1,
      breakpoints: {
          // when window width is >= 768px
          768: {
            slidesPerView: 1,
          }
      },
      scrollbar: {
          dragClass: 'swiper-scrollbar-drag',
          el: '.sfs',
          draggable: true,
      },
      navigation: {
        nextEl: '.sfn',
        prevEl: '.sfp',
      },
    });
  });
  if(foros){
    return (
      <div className="sliderF swiper">
        <div className="swiper-wrapper">
          {foros.map((sld, indexq) => (
              <div className="swiper-slide" key={indexq}>
                  <h3>{sld.ttlo_fro}</h3>
                  <Link className="btn_cntct" to={"/comunidad/"+sld.key_fro}>Dejar mi opinión</Link>
                  <div className="stats">
                      <span className="views"><FaEye /> {sld.vsts_fro}</span>
                      <span className="comments"><FaComments /> {sld.tc ? sld.tc : 0}</span>
                  </div>
              </div>
          ))}
        </div>
        <div className="swiper-button-prev sfp"></div>
        <div className="swiper-button-next sfn"></div>
        <div className="swiper-scrollbar sfs"></div>
      </div>
    );
  }
};

export default Foros;
